import React from "react";
import { Box, Typography, CardContent, Divider, Grid } from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { ClassroomStatsDto } from "../../../shared/dtos/classroom/ClassroomStatsDto";

interface ClassroomWidgetProps {
  data: ClassroomStatsDto;
}

const ClassroomWidget: React.FC<ClassroomWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("CLASSROOM");
  const Icon = meta.icon;

  return (
    <StyledCard
      sx={{ height: "100%", display: "flex", flexDirection: "column" }}
    >
      <CardContent
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {meta.title}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Classrooms: {data.total}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ my: 2 }} />

        <Grid container spacing={2} sx={{ my: "auto", textAlign: "center" }}>
          <Grid size={{ xs: 6 }}>
            <Typography
              variant="h4"
              sx={{ fontWeight: "bold", color: "primary.main" }}
            >
              {data.totalCapacity}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Total Capacity
            </Typography>
          </Grid>
          <Grid size={{ xs: 6 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: "bold",
                color:
                  data.unassignedHomeroom > 0 ? "warning.main" : "success.main",
              }}
            >
              {data.unassignedHomeroom}
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Unassigned Homeroom
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </StyledCard>
  );
};

export default ClassroomWidget;
